import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { profiles } from '../data/testimonials';
import { OFFER_ANCHOR } from '../data/constants';
export function Testimonials() {
  return <section className="bg-white py-5 sm:py-7" data-id="element-190" data-mp="3fz5pc1f45qid">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-191" data-mp="3fxuly2pkykrs">
        <h2 className="text-center text-2xl leading-tight text-navy sm:text-4xl" data-id="element-192" data-mp="3b1487m19019j">
          POUR QUI EST <span className="text-tech" data-id="element-193" data-mp="36zinxfmdwkpb">CE SYSTÈME ?</span>
        </h2>

        <div className="mt-3 grid gap-2 md:grid-cols-2 md:gap-2.5" data-id="element-194" data-mp="36wmpzrajdw0v">
          {profiles.map((profile, i) => <a key={profile.who} href={OFFER_ANCHOR} className={`flex flex-col rounded-xl border border-metal bg-ice p-3 shadow-sm transition-colors duration-150 ease-out hover:border-tech sm:p-4 ${i === 0 ? 'border-l-4 border-l-tech md:col-span-2' : ''}`} data-id="element-195" data-mp="2x0tbi2d9bsgg" data-mpi={i}>
              <h3 className="font-display text-sm font-extrabold leading-tight text-navy sm:text-base" data-id="element-196" data-mp="qbn690wo3ks1">
                <span aria-hidden="true" data-id="element-197" data-mp="h4dcylqnjo46">{profile.icon}</span> {profile.who}
              </h3>
              <p className="mt-1 text-sm leading-snug text-steel" data-id="element-198" data-mp="m5sxmcox3sm1">{profile.situation}</p>
              <p className="mt-1.5 flex items-start gap-1.5 text-sm font-medium leading-snug text-navy" data-id="element-199" data-mp="78tub113mlxd">
                <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-200" data-mp="c7myu3yer2le" />
                {profile.benefit}
              </p>
            </a>)}
        </div>
      </div>
    </section>;
}